// Block Slider Grid — Swiper carousel.
//   - mobile: 1 slide per view with pagination dots,
//   - desktop (>=768px): 2 slides per view.
// Swiper is exposed globally from assets/src/index.js (window.Swiper).

function initSliderGrid(block) {
    const el = block.querySelector("[data-slider-grid]");
    if (!el || !window.Swiper) return;

    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 15,
        pagination: {
            el: el.querySelector(".block-slider-grid__pagination"),
            clickable: true,
        },
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });
}

function initAll() {
    document.querySelectorAll("[data-block-slider-grid]").forEach(initSliderGrid);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
} else {
    initAll();
}
